export enum OrdersEndpoints {
  ROOT = '/orders',
  PUSH = '/push',
}

export const staticOrdersEndpoints = {
  PUSH_ORDER: `${OrdersEndpoints.ROOT}${OrdersEndpoints.PUSH}`,
};

// ============== DTO ==============

export type IPushOrderDTO = {
  orderId: string;
};

// ============== Response ==============

export type IPushOrderResponse = {
  success: boolean;
};
